
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby, langydl, langpty,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: "تداول العملات",
    bba: "حساب العملة",
    hy: "معاملة العقد",
    jg: "العقود الآجلة",
    hya: "حساب العقد"
  },
  home:{
    user:'الاختيار المشترك للمستخدمين',
    start:'بدء التداول',
    trading:'منتجات التداول',
    fee:'الحد الأدنى لرسوم المناولة',
    co:'شركة',
    varieties:'أصناف التداول',
    leading:'قيادة الابتكار واستكشاف الويب 3',
    market:'اتجاهات السوق للمنتجات التجارية',
    explore:'استكشاف الاحتمالات التي لا نهاية لها',
    newcurrency:'وظيفة الاشتراك بالعملة الجديدة متاحة الآن!',
    alimited:'يوجد عدد محدود من العملات الجديدة على الإنترنت. يمكنك شراء العملات الجديدة التي تعتقد أن لها إمكانات هنا.',
    get_start:'البدء في استخدام',
    ai_coin:'خطة كسب عملة الذكاء الاصطناعي قيد التنفيذ',
    ai_text:'ابدأ في كسب العملات المعدنية باستخدام الذكاء الاصطناعي، ودخل ثابت، ومعدل عائد مرتفع، مما يسمح لك بكسب العملات المعدنية أثناء الاستلقاء',
    loan:'وظيفة القرض على الانترنت',
    loan_text:'عندما لا يكون لديك المال، يمكنك التقدم بطلب للحصول على قرض وسيتم إصداره في أقرب وقتفي نفس اليوم',
    mobile_pc:'يمكن استخدامها على كل من أجهزة الكمبيوتر وأجهزة الكمبيوتر',
    pc_anytime:'ابدأ التداول في أي وقت ومن أي مكان:',
    pc_text:'نحن نقدم أدوات قوية لتحليل الرسوم البيانية: أكثر من خمسين مؤشرًا فنيًا وأدوات تحليل القرص. إنها آمنة وموثوقة وسهلة الاستخدام ولها ميزات للمستثمرين المتميزين، مما يجعلها منصة قياسية للاستثمار عبر الإنترنت.',
    mobile_down:'اضغط للتحميل',
    mobile_android:'سوق أندرويد',
    mobile_ios:'متجر آبل',
    open_text:'لا يستغرق الأمر سوى بضع دقائق لتقديم طلب للحصول على حساب تداول حقيقي أو تجربة حسابتجريبي مجانًا',
    open_account:'حساب',
    tocomplete:'لإكمال',
    walletlogin:'تسجيل الدخول إلى المحفظة'
  },
  index: {
     h24: "كمية 24 ساعة",
     header_title: ['اختر لتداول الأصول الرقمية' + window.GLOBAL.LANG_TITLE.zh] ,
     header_small_title: "إكمال معاملة الأصول الرقمية blockchain وقفة واحدة كاملة" ,
     header_msg: "آمن - مستقر - موثوق به" ,
     register_title: "تسجيل واحد" + window.GLOBAL.LANG_TITLE.zh + "حساب المحطة العالمية يبدأ رحلة التداول" ,
     register_pl: "الرجاء إدخال البريد الإلكتروني أو الهاتف المحمول" ,
     register: "تسجيل" ,
     featureTitleWhy: "لماذا تختارنا" ,
     featureTitle: "آمن ومستقر وموثوق" ,
     featureMsg:'',
     featureList: [
       {icon: icon1, title: "Safe wallet technology", msg: ['تم تطوير تقنية المحفظة الباردة والساخنة من قبل فريق الأمن الأعلى في العالم , ولم يكن هناك أي حادث فقدان عملة. ',' ']},
       {icon: icon2, title: "أعمال الأصول المشفرة الواسعة", msg: ['الدعم الفوري والمعاملات المشتقة المتعددة , وما إلى ذلك , هو وكيلك الشخصي لدخول عالم الأصول المشفرة. ',' ']},
       {icon: icon3 , title: "العملاء الموزعون في جميع أنحاء العالم" , msg: ['توفير مجموعة كاملة من الخدمات للأصول المشفرة للمستخدمين في أكثر من 130 دولة أو منطقة حول العالم. ',' ']}
     ],
     bannerList: [
       {icon: banner01, title: "مخصصة لتوفير الأمن والاستقرار الرائدين في الصناعة", الرسالة: ["العقد الذكي يضمن سلامة أصول المستثمرين", "أداء التداول حقيقي", "ضمان خدمة 24 ساعة"]},
       {icon: banner02, title: "أريد أن أشتري وأبيع فورًا من خلال عمليات بسيطة", رسالة: ["شاشة تداول بسيطة", "تنعكس فورًا في رصيد حسابك", "يمكن تداول معظم العملات المشفرة"]},
       {icon: banner03, title: "أريد أن أجني أرباحًا بشكل نشط من خلال تداول عقد التسليم", الرسالة: ["فتح الحساب متاح في نفس الوقت", "الاستثمار الاستراتيجي لعدد كبير من العقود الآجلة للتداول", "365 يومًا أ عام, يمكن تداول 24 ساعة في اليوم, حتى في عطلات نهاية الأسبوع "]}
     ],
     featureList2: [
       {icon: icon1_01, title: "Transparent and Open", msg: ["باستخدام خصائص blockchain والعقود الذكية, يتم تحميل أداء المعاملات فعليًا إلى السلسلة, ويتم استخدام العقود الذكية لضمان سلامة أصول المستثمرين", ""]},
       {icon: icon1_02, title: "Smart Investment", msg: ["لك الحرية في الاختيار من بين الاستراتيجيات المتنوعة التي يقدمها كبار خبراء التداول الكمي", ""]},
       {icon: icon1_03, title: "تصنيف المخاطر", msg: ["تم تصميم منتجات الاستثمار المتنوعة وفقًا للمخاطر المختلفة وتفضيلات إدارة الأصول لكل مستثمر, مما يلغي بشكل فعال عتبة الاستثمار", ""]},
       {icon: icon1_04, title: "Diversified Products", msg: ["قدم أنواعًا مختلفة من احتياجات الاستثمار للمستخدم وآلية منصة مرنة, واستمر في إنتاج خدمات مالية مبتكرة متفوقة على السوق", ""]}
     ],
     featureTitle2: "المعاملات الطرفية متعددة المنصات في أي وقت وفي أي مكان",
     featureMsg2: 'تغطية منصات متعددة لأنظمة iOS و Android, ودعم وظائف الأعمال الكاملة',
     tab: ["العملة الرئيسية", "قائمة مكاسب 24 ساعة"],
     thead: ["الزوج التجاري", "أحدث سعر", "أعلى سعر في اليوم", "أدنى سعر في اليوم", "القائمة المتزايدة", "حجم التداول على مدار 24 ساعة", "العملية"],
     more: "مشاهدة المزيد>",
     btn: "معاملة",
     DealsTitle: "خدمة المعاملات الشاملة" ,
     dealsTab: [
       {title: "معاملات العملة إلى العملة" , content: 'تهدف المعاملات بين العملات إلى التبادل بين الأصول الرقمية , باستخدام USDT كوحدة تسعير لشراء عملات أخرى. '+ window.GLOBAL.LANG_TITLE.zh +' يدعم تداول العملات التداول في الوقت الفعلي للأصول الرقمية مثل Bitcoin و Ethereum و Litecoin. ', src:'/static/image/deals-1.jpg',path: ''},
       {title: 'Contract Transaction', content: 'مشتق مالي للعملة الرقمية لا يدعم فقط خيار شراء عقود طويلة أو قصيرة لكسب الدخل , ولكنه أيضًا سهل التشغيل ولا تنتهي صلاحيته أبدًا. يحتوي عقد "+ window.GLOBAL.LANG_TITLE.zh +" على نظام متقدم لإدارة المخاطر , ويمكن أن تصل الرافعة المالية إلى 100 مرة. ', src:'/static/image/deals-2.jpg',path:''}
     ]
  },
  market: {
    tab: ["اختياري" , "عقد" , "عملة"] ,
    thead: ["العملة" , "أحدث سعر" , "تغيير على مدار 24 ساعة" , "أقل 24 ساعة" , "24 ساعة أعلى" , "حجم تداول على مدار 24 ساعة" , "عملية"] ,
    nodata: "لا توجد بيانات بعد"
  },
  footer: {
    p: '© حقوق النشر  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. كل الحقوق محفوظة.',
    dd: [
      {
        dt: "معلومات عنا",
        dd: [{ title: "ملف الشركة", id: 1 },{ title: "مركز المساعدة", type: 'help' }]
      },
      {
        dt: "دعم المستخدم",
        dd: [
          { title: "اتفاقية المستخدم", id: 3 },
          { title: "سياسة الخصوصية", id: 5 }
        ]
      },
      {
        dt: "اتصل بنا",
        icon: true
      }
    ],
    terms: "الأحكام والشروط",
    serve: "يخدم",
    product: "منتج",
  },
  nav: {
    btn: ["تسجيل الدخول" , "تسجيل" , "إدارة الأصول" , "تنزيل التطبيق"],
    nav: [
      // { title: "الصفحة الأمامية", path: "/index",name: 'index' },
      // { title: "تداول العملات", path: "/deal",name: 'deal' },
      { title: "يقتبس", path: "/market",name: 'market' },
      { title: "تجارة", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "تداول العملات", path: "/deal", name: 'deal'},
      // { title: "معاملة", path: "/deal_c", name: 'deal_c' },
      // { title: "عملة مشفرة", path: "/deal_jg", name: 'deal_jg' },
      { title: "كسب النقودAI", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "أصولي", path: "/asset" }],
    menus: [
      { icon: langzh, title: "مركز المستخدم", path: "/setting" },
      { icon: langen, title: "خروج" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
 { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      // { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "تحميل"
  },
  // 登录
  login: {
    login: "مرحبًا بك في تسجيل الدخول",
    msg: "الرجاء إدخال حسابك المسجل",
    list: ["الهاتف / البريد الإلكتروني" , "كلمة المرور" , "هل نسيت كلمة المرور؟" , "تسجيل الدخول" , "لا يوجد حساب , سجل الآن"],
    message: 'لا يمكن أن يكون الحساب أو كلمة المرور فارغين'
  },
  register: {
    dl: ['تسجيل الهاتف المحمول ', 'تسجيل البريد الإلكتروني'],
    title: "تسجيل حساب",
    country: "الجنسية" ,
    country_info: "لا يمكن تعديل معلومات الجنسية بعد التسجيل , يرجى الاختيار بصدق",
    account: "الحساب" ,
    code_text: "الرجاء إدخال رمز التحقق" ,
    code_btn: "احصل على رمز التحقق" ,
    code_unit: 's',
    code_no_data: "لا يمكن أن يكون رمز التحقق فارغًا",
    password_text: "الرجاء إدخال كلمة المرور",
    password_again_text: "الرجاء إدخال كلمة المرور مرة أخرى",
    pid_text: "رمز الدعوة",
    pid_pl: "اختياري",
    calling_code_no_data: "رمز الدعوة مطلوب",
    xy: "اتفاقية المستخدم",
    xy_no_checked: "الرجاء تحديد بروتوكول",
    agree: "لقد قرأت ووافقت",
    register_btn: "تسجيل",
    bz: ['لا يمكن تعديل بيانات الجنسية بعد التسجيل , يرجى الاختيار بصدق.', 'قد يتم الحكم على رسالة التحقق بشكل خاطئ على أنها بريد عشوائي , يرجى التحقق منها بعناية.', 'يرجى الاحتفاظ بك' + window.GLOBAL.LANG_TITLE.zh + 'رقم الحساب وكلمة مرور تسجيل الدخول.', 'يرجى عدم استخدام نفس كلمة مرور تسجيل الدخول مثل مواقع الويب الأخرى.'],
    account_no_data: "لا يمكن أن يكون الحساب فارغًا",
    code_no_equality: "رمز التحقق غير متساو",
    password_no_data: "لا يمكن أن تكون كلمة المرور فارغة",
    password_no_equality: "كلمتا مرور غير متساويتين"
  },
  // 设置密码
  bindmpwd: {
    title: "تعيين كلمة المرور" ,
    account: "الحساب" ,
    code_text: "الرجاء إدخال رمز التحقق" ,
    code_btn: "احصل على رمز التحقق" ,
    code_unit: 's',
    password_text: "الرجاء إدخال كلمة المرور" ,
    password_again_text: "الرجاء إدخال كلمة المرور مرة أخرى" ,
    code_no_data: "لا يمكن أن يكون رمز التحقق فارغًا",
    code_no_equality: "رمز التحقق غير متساو" ,
    password_no_data: "لا يمكن أن تكون كلمة المرور فارغة",
    password_no_equality: "كلمتا مرور غير متساويتين" ,
    bindmpwd_btn: "تأكيد" ,
    phone_no_data: "لا يمكن أن يكون رقم الهاتف فارغًا" ,
    password_login_text: "الرجاء إدخال كلمة مرور تسجيل الدخول" ,
    password_trade_text: "طول كلمة المرور 6 أرقام" ,
    password_again_tarde_text: "طول كلمة المرور 6 أرقام" ,
  },
  // 忘记密码
  forgetpwd: {
    title: ["تغيير كلمة المرور" , "نسيت كلمة المرور"],
    account: "الحساب",
    code_text: "الرجاء إدخال رمز التحقق",
    code_btn: "احصل على رمز التحقق",
    code_unit: 's',
    password_text: "الرجاء إدخال كلمة المرور",
    password_again_text: "الرجاء إدخال كلمة المرور مرة أخرى",
    phone_no_data: "لا يمكن أن يكون رقم الهاتف فارغًا",
    account_no_data: "لا يمكن أن يكون الحساب فارغًا",
    code_no_data: "لا يمكن أن يكون رمز التحقق فارغًا",
    code_no_equality: "رمز التحقق غير متساو",
    password_no_data: "لا يمكن أن تكون كلمة المرور فارغة",
    password_no_equality: "كلمتا مرور غير متساويتين",
    forgetpwd_btn: "تأكيد"
  },
  // 绑定手机号码
  bindphone: {
    title: "ربط رقم الهاتف المحمول",
    phone_text: "رقم الهاتف المحمول",
  },
  person: {
    more: "تحميل المزيد" ,
    no_more: "لا توجد بيانات",
    index_center: "مركز المستخدم" ,
    index_menus: [
      {icon: zhsz, title: "ادارة الحساب", path: '/setting'},
      {icon: sfrz, title: "المصادقة" , path: '/sfyz'} ,
      {icon: sfrz, title: "المصادقة الأساسية" , path: '/smauth'} ,
      {icon: jtrz, title: "شهادة متقدمة", path: '/Seniorauth'},
      {icon: jtrz, title: "مصادقة العنوان", path: '/dzrz'},
      {icon: jtrz, title: "قم بشراء العملات بسرعة" , path: '/kjmbSelect'} ,
      {icon: jtrz, title: "مستوى الرصيد", path: '/credit'},
      {icon: jtrz, title: "سجلات الحساب", path: '/deallog'},
      {icon: jtrz, title: "سجل الإيداع", path: '/cbjl'},
      {icon: jtrz, title: "سجل الانسحاب", path: '/tbjl'},
    //  { icon: jtrz, title: "我的消息", path: '/news' }
    ],
    cbtb: "الإيداع والسحب" ,
    jymx: "تفاصيل المعاملة" ,
    xyf: {
      "title": "درجة الائتمان",
      "pgsj": "وقت التقييم"
    },
    smrz:{
      title: "مصادقة الاسم الحقيقي",
      sure_title: "لقد اجتزت مصادقة الاسم الحقيقي",
      zj_type: "نوع الشهادة",
      zj_info: ['بمجرد التحقق من معلومات المصادقة ,لا يمكن تعديلها , يرجى التأكد من ملئها بصدق', 'لا يمكن إعادة مصادقة معلومات الاسم الحقيقي المصادق عليها'],
      zj_name: "الاسم",
      zj_num: "رقم الشهادة",
      zj_btn: "موافق",
      zj_rebtn: "إعادة المصادقة",
      zj_sebtn: "التحقق المتقدم",
       zj_type_array:[{name:'بطاقة التعريف',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "بطاقة التعريف"
        },
        {
            id: 2,
            name: "جواز سفر"
        },
        {
            id: 3,
            name: "رخصة قيادة"
        },
        {
            id: 4,
            name: "تصريح المقيمين"
        },
        {
            id: 5,
            name: "آخر"
        }
       ],
       zj_data:{city:'لا يمكن أن تكون الجنسية فارغة',type:'لا يمكن أن يكون نوع الشهادة فارغًا',name:'لا يمكن أن يكون الاسم فارغًا',zj_num:'لا يمكن أن يكون رقم الهوية فارغًا'},
       zsxm: "الاسم الحقيقي",
       qsrzsxm: "الرجاء إدخال اسمك الحقيقي",
       zjlx: "نوع الشهادة",
       qxzzjlx: 'الرجاء تحديد نوع المستند',
       sfz: "بطاقة الهوية",
       zjhm: "رقم المستند",
       qsrzjhm: 'الرجاء إدخال رقم الهوية',
       sczjz: 'تحميل صورة الهوية',
       zjzm: 'تحميل الصورة الأمامية للشهادة',
       zjfm: 'تحميل الصورة الخلفية للشهادة',
       qsczjzm: 'الرجاء تحميل صورة أمامية لبطاقة الهوية الخاصة بك',
       qsczjfm: 'الرجاء تحميل صورة من ظهر المستند',
       scqmz: 'تحميل الشهادة وصورة التوقيع الشخصي',
       qscscqmz: "يرجى تحميل شهادتك وصورة التوقيع الشخصي",
       zj: [
         {
           id: 1,
           title: 'بطاقة التعريف'
         },
         {
           id: 2,
           title: 'جواز سفر'
         },
         {
           id: 3,
           title: 'آخر'
         },
       ],
       tj: "إرسال",
       shz: "قيد المراجعة",
       shtg: "موافق عليه"
    },
    gjrz:{
      title:'شهادة متقدمة',
      zj_info:['دعم الصور بتنسيق JPG أو JPEG أو PNG أقل من 8M.','يجب أن تكون صورة الهوية واضحة , ولا يسمح بأي تعديل أو تغطية , ويجب أن تكون الصورة الشخصية ورقم الهوية والاسم ظاهرين بوضوح.','3. يجب أن تكون الصورة "عاري الرأس" , ولا ينصح بالمكياج , وتكون ملامح وجه الشخص الحامل للشهادة مرئية بوضوح , والذراعين مكشوفان تمامًا'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'اعدادات الامان',
      bind:[{bind_title:'إعادة تعيين كلمة المرور',bind_name:'بريد'},{bind_title:'قم بتعيين كلمة مرور المعاملة',bind_name:'بريد'}]
    },
    wdtg:{
      own_code: "كود دعوة حصري",
      own_code_url: "رابط دعوة حصري",
      own_push_title: "ترقيتي" ,
      own_push_content: ["إجمالي دخل الدعوة (التقييم)" , "رقم الدعوة" , "الأشخاص"] ,
      own_push_content_profit: ["ربح دعوة المستوى 1" , "ربح دعوة المستوى الثاني" , "ربح دعوة المستوى الثالث" , "ربح دعوة المستوى الرابع"] ,
      own_push_content_num: ["عدد المدعوين في المستوى الأول" , "عدد المدعوين في المستوى الثاني" , "عدد المدعوين في المستوى الثالث" , "عدد المدعوين في المستوى الرابع"] ,
      own_push_profit_title: ["المعرف" ,"الإيرادات" ,"الملاحظات" ,"إضافة الوقت"],
      own_push_num_title: ["المعرف" , "الاسم" , "الهاتف" , "إضافة الوقت"],
    },
    jyzt_td: ["الوقت", "التفاصيل", "المبلغ"],
    cbjl_td: ["الوقت", "العملة", "الكمية", "الحالة"],
    sfrz_txt: ["مصادقة الهوية", "لقد قدمت المراجعة, يرجى انتظار النتيجة", "لقد اجتزت المصادقة المتقدمة", "واجهة بطاقة الهوية", "عودة بطاقة الهوية", "المصادقة", "فشلت المصادقة, يرجى إعادة- مصادقة "],

    zhsz_txt: ["مستوى أمان حسابك: #", "مستوى أمان حسابك: #, أكمل المزيد من المعلومات لضمان أمان الحساب"],
    zhsz_m: "قوي",
    zhsz_n: "ضعيف",
    zhsz_p: "غير آمن",
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀请码', value: '', btn: '复制邀请码', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用于登录、提币、安全设置时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改密码，安全设置时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: 'كلمة سر الدخول', value: 'حسابات الإنترنت معرضة لخطر السرقة , يوصى بتغيير كلمة المرور الخاصة بك بانتظام لحماية أمان حسابك.',value2:'', btn: 'يراجع',bind_email:'يرجى ربط بريدك الإلكتروني أو هاتفك المحمول أولاً', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'عملية كلمة المرور', value: 'تعيين كلمة المرور تعيين كلمة المرور', btn: 'اذهب للاعدادات', path: '/bindmpwd' }
    ],
    sksz_txt: ["إعدادات الاستلام" , "حفظ"],
    sksz_list: [
      {label: "اسم المستخدم:", pl: "الرجاء إدخال اسم المستخدم", key: "name"},
      {label: "اسم بنك فتح الحساب:", pl: "الرجاء إدخال اسم بنك فتح الحساب", key: "bank_name"},
      {label: "رقم البطاقة المصرفية:", pl: "الرجاء إدخال رقم البطاقة المصرفية", key: "bank_number"},
      {label: "رقم حساب Alipay:", pl: "الرجاء إدخال رقم حساب Alipay", key: "alipay_account"},
      {label: "لقب WeChat:", pl: "الرجاء إدخال اسم مستعار WeChat", key: "weixin_nickname"},
      {label: "حساب WeChat:", pl: "الرجاء إدخال حساب WeChat", key: "weixin_account"}
    ]
  },
  pasination: {
    first: "الصفحة الرئيسية",
    prev: "الصفحة السابقة",
    next: "الصفحة التالية",
    last: "الصفحة الأخيرة",
    no_data: "لا توجد بيانات بعد",
  },
  asset: {
    title: "أصولي",
    zjhz: "تحويل الأموال",
    cb: "إيداع العملة",
    gz: "تقييم USDT",
    atnv: [],
    zh_title: "إجمالي الأصول المكافئة:",
    index_title: "الأصول",
    address_title: "العملة",
    address_txt: ["الرجاء تحديد", "عنوان السحب", "الرجاء إدخال المحتوى", "الملاحظات", "قائمة العناوين"],
    address_btn: ["إضافة", "حفظ", "حذف", "تعديل"],
    address_td: ['العملة', 'عنوان السحب', 'الملاحظات', 'العملية'],
    currency_td: ["العملة", "المتاحة", "المجمدة", "المحولة"],

    table_title: "إجمالي الأصول:",
    table_address_title: "إدارة عنوان السحب",
    table_td: ["العملة", "المتاحة", "المجمدة", "التحويل", "العملية"],
    table_btn: ["إيداع", "سحب", "تسجيل", "تحويل"],

    money_text: ["عنوان السحب", "يرجى تحديد", "الكمية", "المتاحة:", "رسوم المناولة",
       "المبلغ المستلم", "كلمة مرور المعاملة", "التسمية (المذكرة)", "الحد الأدنى للسحب"],
    money_btn: "سحب",
    xzbz: "اختر العملة",
    money_msg: ["تذكير", "1. وقت السحب هو 12: 00-24: 00 بتوقيت هونغ كونغ, يمكنك تقديم طلبين للسحب يوميًا (الحد الأدنى للسحب 100u, الحد الأقصى للسحب 200,000u) ؛", "2. حاليًا, فقط عملة USDT مدعومة لسحب العملة, ونوع رابط المحفظة هو ERC20 ؛ "," 3. بعد تقديم طلب سحب العملة, تكون الأموال في حالة مجمدة لأن السحب قيد التقدم, وتتم إدارة الأموال مؤقتًا بواسطة النظام ولا يمكن أن تدار من قبلك مجانا. هذا لا يعني أنك فقدت هذا الأصل أو أن هناك خطأ ما به. الرجاء الانتظار بصبر للحصول على الموافقة ؛ ',' 4. بعد تقديم طلب السحب, يخضع وقت الوصول لوقت تأكيد الحظر. إذا لم يتم استلام الدفعة بعد وقت السحب المتوقع, فيرجى استشارة خدمة العملاء للاستفسارات ؛ ',' 5. لمنع سلوك السحب النقدي, مطلوب 90٪ من إجمالي مبلغ الاستهلاك لبدء السحب "],

    recharge_title: "عنوان الشحن",
    recharge_btn: ["نسخ" , "رمز الاستجابة السريعة" , "إعادة الشحن"] ,
    recharge_text: ["الكمية" , "تذكير" ,'لا تعيد شحن أي أصول بخلاف USDT إلى العنوان أعلاه , وإلا فلن يتم استرداد الأصول.', 'تدعم ودائع USDT فقط طريقة الإرسال البسيطة, ولا يمكن ترحيل الودائع باستخدام طرق أخرى (إرسال الكل) مؤقتًا, يرجى فهم ذلك.', "الشهادة" , "وصف الشهادة (اختياري)" , "اسم السلسلة"],

    Record_title: "السجلات المالية",
    Record_td: ["الكمية" , "التسجيل" , "الوقت"] ,

    transfer_title: "تحويل",
    transfer_btn: ["الكل", "نقل"],
    transfer_text: ["من", "إلى", "الرجاء إدخال مبلغ التحويل", "متاح:"],
    "bq": "التسمية (مذكرة)",
    "qsrbq": "الرجاء إدخال تسمية" ,
    "yhktx": "السحب النقدي بالبطاقة المصرفية",
    "yhmc": "اسم البنك",
    "qsryhmc": "الرجاء إدخال اسم البنك",
    "yhzh": "رقم الحساب المصرفي" ,
    "qsryhzh": "الرجاء إدخال رقم الحساب المصرفي" ,
    "gjhkdm": "رمز التحويل الدولي" ,
    "qsrgjhkdm": "الرجاء إدخال رمز التحويل الدولي" ,
    "yhdz": "عنوان البنك",
    "qsryhdz": "الرجاء إدخال عنوان البنك",
    "skrxm": "اسم المدفوع لأمره",
    "qsrskrxm": "الرجاء إدخال اسم المدفوع لأمره" ,
    "skrdh": "هاتف المدفوع لأمره",
    "qsrskrdh": "الرجاء إدخال رقم هاتف المدفوع لأمره" ,
    "skrdz": "عنوان المدفوع لأمره",
    "qsrskrdz": "الرجاء إدخال عنوان المدفوع لأمره"
  },
  text: {
    btn: "عودة",
    login: "الرجاء تسجيل الدخول أولا"
  },
  deal: {
    chooseType: "نوع التفويض",
    choose: "الرجاء الاختيار",
    balance: "الرصيد:",
    account: ["الحساب", "متاح", "/تجميد", "تحويل"],
    dir: ['شراء','بيع'],
    dir2: ["متاح للشراء", "متاح للبيع"],
    cs: "اختياري",
    sxf: "معدل رسوم المناولة",
    jye: "مبلغ المعاملة",
    sc_list: ["سوق", "زوج عملات", "زيادة"],
    sc_h: ["السعر الحالي", "أدنى سعر على مدار 24 ساعة", "أعلى سعر على مدار 24 ساعة", "حجم تداول على مدار 24 ساعة"],
    td_lt: ["العملة", "آخر سعر", "زيادة"],
    k_line_txt: ["≈", "", "زيادة", "أعلى سعر", "أدنى سعر", "حجم 24 ساعة"],
    tabListLTitle: ["النظام الحالي", "الترتيب التاريخي"],
    tabListLEntrust: ['شراء' ,'بيع'],
    tabListRTitle: ["أمر الحد", "أمر السوق"],
    table_btn: ['إلغاء'],
    index_td_l: ["الوقت", "كائن التداول", "الكمية", "السعر", "العملية"],
    index_td_r: ["أحدث سعر", "اتجاه", "السعر", "الكمية"],
    index_td_r2: ["أحدث معاملة", "الوقت", "السعر", "الحجم"],
    table_txt: ["مكتمل", "ملغى"],

    db_1_txt: ["متاح", "سعر الشراء", "سعر البيع", "مبلغ الشراء", "مبلغ البيع", "مبلغ المعاملة", "الشراء بأفضل سعر في السوق", "البيع بأفضل سعر في السوق", "شراء اليد ","بيع اليد"],
    db_2_txt: ["السعر", "الرافعة المالية", "الرجاء تحديد", "حجم اللوت", "اللوت الواحد =", "اللوت", "القيمة السوقية للعقد", "الهامش", "الشراء بأفضل سعر في السوق", " شراء بأفضل سعر في السوق بيع "],
    pathList: ["سجل العقد", "سجل المعاملات"],
    db_btn: ["شراء (طويل)" , "بيع (قصير)"],
    tabListLTitle2: ['العمولة الحالية'],

    lt_btn: ["إغلاق المركز بنقرة واحدة", "تعيين سعر جني الأرباح ووقف الخسارة", "إغلاق المركز", "إرسال فورًا", "إرجاع"],
    lt_txt: ["معدل المخاطرة:", "إجمالي الربح والخسارة للمركز:"],
    lt_td: ["النوع" , "الرافعة المالية المتعددة" , "سعر المركز" , "السعر الحالي" , "الهامش" , "سعر جني الأرباح" , "سعر إيقاف الخسارة" , "وقت الافتتاح" , "حجم العقد" , "الربح والخسارة" , "تشغيل"],
    lt_dl: ["تعيين سعر وقف الربح", "سعر جني الأرباح", "سعر إيقاف الخسارة"],

    lt_0_btn: ['إلغاء'],
    lt_0_td: ["جهة الاتصال", "العملة", "الكمية", "السعر الحالي", "الرسوم", "العملية"],

    lt_1_btn: ['أغلق المركز'],
    lt_1_txt: ['إغلاق'],
    lt_1_td: ["النوع", "سعر المركز", "السعر الحالي", "الهامش", "سعر جني الأرباح", "سعر إيقاف الخسارة", "وقت فتح المركز", "رسوم المناولة", "الربح والخسارة", "العملية"],
    node_data: 'لايوجد بيانات',

    lt_3_txt: ["مركز مغلق", "مركز مغلق"],
    lt_3_td: ["النوع", "حجم اللوت", "سعر المركز", "سعر الإغلاق", "سعر جني الأرباح", "سعر إيقاف الخسارة", "الهامش", "الهامش المتاح", "وقت الفتح", "وقت الإغلاق", 'رسوم المعالجة',
    "ربح وخسارة", "عملية"],

    lt_4_txt: ['ألغيت'],
    cm: ["وقت الإصدار", "إجمالي التداول", "إجمالي التداول", "السعر الإجمالي", "الموقع الرسمي", "المستند التقني", "المقدمة"],
    qsrsl: "الرجاء إدخال الكمية",
    qsrss: "الرجاء إدخال حجم اللوت",
  },
  notice:{
      notice_title:'مركز الاعلان',
  },
  bzhl:{
    title: "كسب النقودAI",
    title1: 'القياس الكمي للذكاء الاصطناعي',
     ttzbt: "كسب المال كل يوم" ,
     wdtg: "استضافتي" ,
     zztgdzj: "إدارة الأموال" ,
     yjjrsy: "الدخل اليومي المقدر" ,
     ljsy: "الدخل المتراكم" ,
     tgzdd: "أمر في الحجز" ,
     tgdd: "طلب الضمان" ,
     t1: "إدارة مالية منخفضة المخاطر ومستقرة , يمكنك استردادها في أي وقت إذا لزم الأمر" ,
     t2: "مساعد إدارة الأموال الفائضة" ,
     cljxcp: "دورة المنتج" ,
     dbxe: "حد واحد" ,
     rsyl: "معدل العائد اليومي (٪)" ,
     rsyl2: "معدل العائد اليومي:",
     zq: "فترة" ,
     qmr: "اذهب للشراء" ,
     ckgd: "مشاهدة المزيد" ,
     cpgk: "نظرة عامة على المنتج" ,
     pxsj: "وقت التوزيع" ,
     tgzj: "أموال الضمان" ,
     tqsh: "سحب الفداء" ,
     cpld: "أبرز المنتجات" ,
     cpgz: "قواعد المنتج" ,
     cont: "نقل الطوب هو تكليف USDT إلى المنصة , وسيقوم الفريق المحترف في المنصة بتنفيذ الحق في نقل الطوب. خلال فترة حفظ الأموال , يمكن للمشاركين الحصول على حصة عائدات نقل الطوب الخاصة بالمنصة , والتي يمكن إيداعها وسحبها في في أي وقت , وهو آمن ومريح. ",
     zj: "أموال 100٪" ,
     aqbz: "ضمان أمني",
     jjrsy: "دخل العطلة" ,
     bjd: "غير منقطع" ,
     cgcrh: "بعد الإيداع الناجح" ,
     dtqx: "ابدأ اليوم" ,
     ljzr: "نقل في الحال" ,
     xqglgj: "أداة إدارة الأموال الخاملة" ,
     ddh: "رقم الطلب" ,
     tgje: "مبلغ الضمان" ,
     tgsj: "أيام الدورة" ,
     yhl: "الربح المكتسب / الأيام المتبقية",
     xdsj: "وقت الطلب" ,
     zt: "الحالة" ,
     fh: "عودة" ,
     qrnhsy: "دخل سنوي لمدة 7 أيام" ,
     ygy: "شهر واحد" ,
     bn: "نصف عام" ,
     yn: "سنة واحدة",
     yuan: "يوان",
     tzfx: "مخاطر الاستثمار" ,
     shsc: "مدة الاسترداد",
     di: "منخفض" ,
     yggzr: "يوم عمل واحد" ,
     msgsxf: "رسوم شراء مجانية" ,
     mr: "يوميا" ,
     dqfh: "عودة مستحقة" ,
     ljgm: "اشترِ الآن" ,
     tgz: "استضافة" ,
     sh: "الفداء" ,
     ywc: "مكتمل",
     ysh: "تم الاسترداد" ,
     all: "الكل" ,
     "xzbzts": "بسيط وآمن. يمكن اختيار عملات متعددة لتوزيع الأرباح",
     "qtbz": "عملات أخرى"
  },
  pay:{
    qsrjymm: "الرجاء إدخال كلمة مرور المعاملة المكونة من 6 أرقام",
    tbmmts: "الرجاء الانتقال إلى مركز المستخدم لتعيين كلمة مرور المعاملة",
  },
  tips:{
    qxztbdz: "الرجاء إدخال عنوان السحب",
    qsrtbsl: "الرجاء إدخال مبلغ السحب"
  },
  statusText: ["فشل", "معلق", "نجاح"],
  dzrz: {
    title: "مصادقة العنوان",
     sdddz: "عنوان فاتورة المياه",
     zdtpsc: "تحميل صورة الفواتير",
     qsrsdddz: "تحتاج إلى ملء معلومات العنوان وإرسال الفواتير لفواتير الخدمات العامة أو عناوين النطاق العريض",
     qsczdtp: 'الرجاء تحميل صورة الفاتورة',
     status: ['قيد المراجعة', 'موافق عليه'],
     qd: "موافق",
  },
  jgcc: {
    wtgd: "تعيين أمر معلق",
     cj: "صفقة",
     jj: "مقدمة",
     zc: "عقد",
     lszc: "مواقف تاريخية",
     qblx: "جميع الأنواع",
     xj: "السعر الحالي",
     sj: "الوقت",
     fx: "الاتجاه",
     jg: "السعر",
     sl: "الكمية",
     jgsj: "وقت التسليم",
     gmj: "سعر الشراء",
     jsj: "سعر التسوية",
     yk: "الربح والخسارة",
     xq: "تفاصيل",
     mz: "شراء",
     md: "شراء",
     dqye: "الرصيد الحالي",
     gb: "إغلاق",
     jxxd: "متابعة تقديم طلب",
     qrxd: "تأكيد الطلب",
     ddqr: "تأكيد الطلب",
     sxf: "رسوم المناولة",
     kyye: "الرصيد المتاح",
     jypz: "تجارة الأنواع",
     jyfx: "اتجاه التداول",
     tzje: "مبلغ الاستثمار",
     tzjeTips: "لا يمكن أن يكون مبلغ الاستثمار 0",
     dqsj: "وقت انتهاء الصلاحية",
     jssj: "وقت التسوية",
     gmsj: "وقت الشراء",
     sy: "الدخل",
     zxje: "الكمية الدنيا",
     shi: "الوقت",
     fen: "نقطة",
     miao: "الثانية",
     zdje: "الكمية القصوى",
     qsrje: "الرجاء إدخال المبلغ",
     zxtzje: "الحد الأدنى من الكمية",
     yebz: "رصيد غير كافٍ",
     xq: "تفاصيل",
     ddz: "انتظار",
     jgjl: "سجل التسليم",
     bz: "العملة",
     cz: "عملية"
  },
  kjmb: {
    title: "عملة الشراء السريع",
     fzcg: "نسخ ناجح",
     ljmb: "شراء العملات المعدنية الآن",
     lxkf: "الاتصال بخدمة العملاء"
  },
  news: {
    title: 'أخباري',
    "gg": "إعلان",
    ckxq: 'تحقق من التفاصيل'
  },
  statusTabs:["أمر معلق", "صفقة جارية", "مركز مغلق", "أمر تم إلغاؤه"],
  "chongzhi":{
    "zy": "انتباه" ,
    "tips2": "توافق المحفظة / النظام الأساسي: دعم الشبكة ؛ إذا كانت المنصة المستهدفة لا تدعم شبكة السحب الخاصة بك , فلن يتم استرداد الأصول.",
    "tips3": "شبكة إعادة الشحن والنظام الأساسي المستهدف متماثلان ؛ إذا اخترت العنوان المستهدف ليكون شبكة Ethereum , ولكنك اخترت سلسلة TRC20 الذكية لإعادة الشحن , فقد لا تتمكن من استرداد الأصول الرقمية الخاصة بك.",
    "tips4": "تأكد من صحة عنوانك,المبلغ قبل إعادة الشحن.",
    "tips5": "تذكير: نظرًا لإخفاء الهوية وخصوصية شبكة الحظر , بمجرد إدخال معلومات خاطئة , ستفقد الأصول المقابلة. يرجى التأكد من التحقق بعناية من عنوان ومبلغ إعادة الشحن الخاص بك" ,
    "cbxx": "معلومات إيداع العملات",
    "qsrsl": "الرجاء إدخال مبلغ الإيداع" ,
    "tips2_1": "• لا تودع أي أصول بعملة غير محلية على العنوان أعلاه , وإلا لا يمكن استرداد الأصول.",
    "tips2_2": "• لا يمكن أن تصل العملة الرقمية في الوقت المناسب , ويعتمد وقت الوصول الفعلي على سرعة تأكيد blockchain.",
    "tips2_3": "• لن يتغير عنوان إعادة الشحن الخاص بك بشكل متكرر , ويمكنك إعادة الشحن مرارًا وتكرارًا ؛ إذا كان هناك أي تغيير , فسنبذل قصارى جهدنا لإعلامك من خلال إعلانات الموقع أو رسائل البريد الإلكتروني.",
  },
  "tibi":{
    "tbxx": "معلومات السحب",
    "qsrbq": "الرجاء إدخال علامة",
    "tbTips1": "من أجل ضمان سلامة الأموال , عندما تتغير سياسة أمان حسابك وتغيير كلمة المرور , سنراجع السحب يدويًا , يرجى الانتظار بصبر حتى يتصل بك فريق العمل عبر الهاتف أو البريد الإلكتروني.",
    "tbTips2": "تأكد من تأكيد أمان الكمبيوتر والمتصفح لمنع العبث بالمعلومات أو تسريبها.",
    "tbTips3": "الأصول الرقمية التي ذكرتها هي أصول متعددة السلاسل مكونة من عملة واحدة. بغض النظر عن السلسلة التي تختار الانسحاب منها , فهذا يعني أن المبلغ الإجمالي للأصول الرقمية المعروضة في صفحة السحب التي تمتلكها سيتم تخفيضها بمقدار العدد المقابل لعمليات السحب ",
  },
  "gjlb": "قائمة البلدان",
  "qxzgjlb": "الرجاء تحديد بلد / منطقة" ,
  "mbwt":{
    "title": "إعدادات سؤال أمان كلمة المرور",
    "mbwt": ".مسألة أمان",
    "problem":[
      {
        "id": 1,
        "title": "من كان صديقك المفضل عندما كنت طفلاً؟"
      },
      {
        "id": 2,
        "title": "من هو قدوتك؟"
      },
      {
        "id": 3,
        "title": "اين مكانك المفضل"
      }
    ],
    "qtxda": "الرجاء ملء الإجابة",
    "qsrxmm": "الرجاء إدخال كلمة مرور جديدة" ,
    "qqrmm": "الرجاء تأكيد كلمة المرور" ,
    "sydqmmcz": "إعادة تعيين بكلمة المرور الحالية",
    "zhmm": "سؤال سري لاسترداد كلمة المرور",
    "ysz": "تعيين",
    "tg": "تخطي",
    "tj": "إرسال" ,
    "zyts": "ملاحظة مهمة:" ,
    "zytsCont": "الرجاء عدم الكشف عن إجابة الأمان ورمز التحقق , وتذكر سؤال الأمان , والذي سيساعدك على استرداد كلمة المرور الخاصة بك"
  },
  "zc":{
    "zclb": "قائمة الأصول",
    "zczh": "تحويل الأصول" ,
    "yczc": "الأصول مخفية كـ 0"
  },
  "indexNew":{
    "t1": "الرائد العالمي",
    "t2": "منصة خدمة الأصول الرقمية" ,
    "t3": "إكمال معاملة الأصول الرقمية blockchain ذات المحطة الواحدة" ,
    "t4": "رقم الهاتف المحمول / البريد الإلكتروني",
    "t5": "سجل الآن",
    "t6": "نرحب بالعملاء من جميع أنحاء العالم من خلال MFTG" ,
    "t7": "اكتشف وابدأ رحلة التشفير الخاصة بهم"
  },
  "newReg":{
    "dl": ["بريد إلكتروني", "جوّال"],
    "cjzh": "إنشاء حساب",
    "sysjhzyx": "التسجيل برقم الجوال / البريد الإلكتروني",
    "yhxy": "اتفاقية المستخدم",
    "yhxy2": "لقد قرأت اتفاقية المستخدم وأوافق عليها",
    "yxgz": "عنوان البريد الإلكتروني الذي تم إدخاله لا يتوافق مع القواعد",
    "dhgz": "تنسيق رقم الهاتف المحمول الذي تم إدخاله غير صحيح"
  },
  "indexNew2":{
    "t1": "تداول بناءً على طلبنا",
     "t2": "استخدام BitBank",
     "t3": "Bit Bank عبارة عن Bitcoin مصمم ببراعة وتبادل الأصول المشفرة وهو بسيط للغاية ومريح وآمن وقوي. وهو يدعم المعاملات على العديد من منصات الويب والهواتف الذكية. يتم تحديث بيانات المعاملات والرسوم البيانية في الوقت الفعلي, لسوق شامل يوفر تحليل الأسعار أكثر من 60 أداة للتحليل الفني. ابدأ التداول ",
     "ksjy": "ابدأ التداول",
     "ly": "5 أسباب لاختيار Bitbank",
     "item1_t1": "حجم التداول الرائد",
     "item1_t2": "رقم 1 * حجم تداول الأصول المشفر",
     "item1_t3": "سيولة عالية, تداول مريح (تجربة تداول ممتعة). قائمة 12 من الأصول المشفرة.",
     "item2_t1": "تقييم مرتفع من جهة خارجية",
     "item2_t2": "بيئة تداول آمنة",
     "item2_t3": "استخدم المحفظة الباردة بلا اتصال. حافظ على المتسللين بعيدًا باستخدام Multisig. احم أصولك بتقنية عالية",
     "item3_t1": "تطبيق سهل الاستخدام وموثوق",
     "item3_t2": "تطبيق سهل الاستخدام",
     "item3_t3": "تطبيق موثوق به مع ميزات غنية. تداول بالخارج لإبقاء الصفقات مفتوحة.",
     "item4_t1": "24/7",
     "item4_t2": "متاح للإيداع",
     "item4_t3": "دعم الإيداع على مدار 24 ساعة, بما في ذلك أيام العطل!",
     "item5_t1": "الهاتف الذكي والكمبيوتر الشخصي",
     "item5_t2": "تصميم متوافق مع البشر",
     "item5_t3": "معاملات سهلة ومؤهلة بدون تردد حتى مع الهاتف الذكي",
     "aqkk": "آمن وموثوق",
     "aqkk2": "معاملات البيتكوين في Bitbank",
     "cjzh": "إنشاء حساب",
  },
  xbsg: {
    title: "منطقة العملات الجديدة" ,
    wdsg: "التفاصيل",
    scts: "أيام الحجز:",
    sy: "المتبقية",
    ljsg: "اشترك الآن",
    ysk: "نفدت الكمية" ,
    xzjdy: "اشترك الآن",
    dy: "اشتراك" ,
    fxjg: "سعر الإصدار",
    fxl: "التداول" ,
    ssrq: "تاريخ الإدراج",
    yxqx: "فترة الصلاحية",
    qsrsl: "الرجاء إدخال المبلغ",
    syl: "المتبقية",
    sgrq: "اشتراك",
    sgsl: "المبلغ",
    bz: "عملة",
    yebz: "رصيد USDT غير كافٍ" ,
    tgsl: "تمرير الكمية",
    shz: "قيد المراجعة",
    wtg: "لم تمر" ,
    ytg: "تم اجتيازه"
  },
  wydb: {
    title: "استعارة",
    db: "استعارة",
    dbz: "استعارة",
    jl: "سجل",
    jdzq: "الفترة (أيام)",
    qhk: "للسداد" ,
    ljdb: "تراكمي (usdt)" ,
    dhkbs: "الدفع المعلق",
    jkje: "مبلغ القرض (دولار أمريكي)" ,
    qsrje: "الرجاء إدخال المبلغ" ,
    rll: "سعر الفائدة اليومي",
    hkfs: "السداد",
    dqych: "منتهية الصلاحية",
    lx: "الفائدة",
    fkjg: "المُقرض" ,
    tpsc: "قرض ائتماني (تحميل صورة)",
    fwxx: "معلومات السكن" ,
    srzm: "إثبات الدخل (علاقة العمل)" ,
    yhmx: "كشف حساب بنكي",
    zjz: "صورة الهوية" ,
    yd: "لقد قرأت ووافقت" ,
    xy: "التقدم بطلب للحصول على اتفاقية قرض" ,
    sqdb: "انقر لتقديم طلب للحصول على سلاسل القروض",
    gb: "إغلاق",
    qd: "موافق",
    ts: "الرجاء تحديد التقدم بطلب للحصول على اتفاقية قرض" ,
    dbjl: "سجل",
    hkhth: "كود الطلب" ,
    wsh: "لم تتم مراجعته",
    yfk: "قرض",
    sqrq: "وقت التطبيق",
    zq: "دورة",
    dbsl: "عدد الأضلاع",
    zhke: "إجمالي الدفع" ,
    yhkxq: "تفاصيل السداد",
    bqyhk: "قابل للسداد في الفترة الحالية (USDT)" ,
    hktips: "الرجاء التأكد من أن الرصيد كافٍ , إذا كان الرصيد غير كاف , يرجى إعادة الشحن أولاً ثم السداد ",
    bj: "الرئيسي",
    jie: "استعارة",
    ljhk: "سداد فوري",
    qcz: "للإيداع",
    yebzqxcz: "رصيد غير كاف , يرجى إعادة الشحن أولاً ثم السداد" ,
    znj: "رسوم السداد المتأخر" ,
    yqts: "الأيام المتأخرة"
  } ,
  hkxq: {
    dd: "طلب",
    fzhkdz: "انسخ عنوان السداد" ,
    hkxq: "تفاصيل السداد",
    zlx: "إجمالي الفائدة",
    zhk: "إجمالي السداد" ,
    hkjg: "وكالة السداد",
    qschkpz: "الرجاء تحميل شهادة السداد" ,
    hkpz: "شهادة السداد"
  } ,
  bbjyNew: {
    jylx: "أنواع",
    jyze: "المبلغ"
  },
  "bind":{
    title: "مصادقة البريد الإلكتروني",
    ybd: "منضم",
    wbd: "غير منضم",
    yrz: "تم التحقق منه" ,
    wrz: "لم يتم التحقق منه",
    ts: "لحماية حسابك , يوصى بربط عنوان بريد إلكتروني" ,
    qsryxdz: "عنوان البريد الإلكتروني"
  },
  "tipsNew": {
    "yjj": "مرفوض",
    "shz": "استرداد"
  },
  "newIndex2":{
    "zxhy": "أحدث عروض الأسعار",
     "jypt": "منصة التداول" ,
     "ssyc": "تقليص مخفي",
     "hwzc": "غير مسجل بعد؟",
     "ljzc": "اشترك الآن لاكتشاف الكثير من الفرص!" ,
     "yyzh": "هل لديك حساب بالفعل؟" ,
     "hjbj": "قم بتسجيل الدخول إذا كان لديك حساب , لم أتمكن من رؤيته منذ وقت طويل!" ,
     "lmdh": "التنقل في العمود",
     "ghdjy": "صفقة أفضل حياة أفضل",
     "ghdjy02": "منصة تبادل العملات المشفرة الأكثر ابتكارًا في العالم موجودة هنا , حيث يمكنك شراء العملات المشفرة وتداولها وكسبها بمئات منها في متناول يدك.",
     "indexCont01": "بجانبك دائمًا",
     "indexCont02": "تداول أسواقنا الفورية والهامشية بخيارات تمويل متقدمة وتنفيذ سريع للغاية وسيولة عميقة.",
     "indexCont03": "واجهة برمجة تطبيقات قوية" ,
     "indexCont04": "قم بإدارة مراكزك بسهولة من خلال واجهة برمجة التطبيقات سهلة الاستخدام ومنصة التداول وخيارات الطلبات المتقدمة.",
     "indexCont05": "الأصول الرقمية عالية الجودة",
     "indexCont06": "0 حوادث في 9 سنوات",
     "indexCont07": "أعلى مراقبة مخاطر الأمان",
     "indexCont08": "رافعة مالية تصل إلى 25 مرة",
     "indexCont09": "تداول عقود الفروقات على Bitcoin برافعة مالية تصل إلى 25 ضعفًا.",
     "indexCont010": "احتياطي الأمان",
     "indexCont011": "سيولة عميقة",
     "indexCont012": "تعمل تقنية الطلبات متعددة الأسواق المتقدمة الخاصة بنا على تحسين السيولة وتشديد الهوامش وتقليل الانزلاق.",
     "indexCont013": "المستخدم المفضل",
     "indexCont014": "البلد المغطاة",
     "indexCont015": "مزايانا",
     "indexCont016": "تداول أسواقنا الفورية والهامشية بخيارات تمويل متقدمة وتنفيذ سريع للغاية وسيولة عميقة.",
     "indexCont017": "التخزين الآمن",
     "indexCont018": "نستخدم مزيجًا من المحافظ الباردة وتقنية الحساب متعدد الأطراف (MPC) لإدارة الأصول الرقمية.",
     "indexCont019": "السلامة أولاً",
     "indexCont020": "نستخدم أحدث التقنيات للحفاظ على أمان أموالك والبقاء في طليعة نقاط الضعف ومحاولات الاستغلال.",
     "indexCont021": "سحب سريع",
     "indexCont022": "باستخدام MPC , يمكننا تقديم عمليات سحب سريعة على مدار الساعة طوال أيام الأسبوع مع الحفاظ على معايير الأمان الصارمة الخاصة بنا.",
     "indexCont023": "شراء وبيع العملات المشفرة" ,
     "indexCont024": "انضم إلى منصة التداول الأكثر شمولاً وأمانًا في العالم" ,
     "indexCont025": "قم ببيع وشراء Bitcoin و Ethereum و XRP والعديد من العملات المشفرة الأخرى باستخدام العملات الورقية أو العملات المشفرة.",
     "yqwj": "10 مليون +",
     "dlzc": "تسجيل الدخول" ,
     "yzm": "رمز التحقق" ,
     "qrmm": "تأكيد كلمة المرور"
  },
  "langNew2":{
    "flzq": "مركز المكافآت",
    "qdjl": "مكافأة تسجيل الدخول",
    "mrqdjl": "مكافأة تسجيل الدخول اليومية",
    "qd": "تسجيل الدخول",
    "yqd": "تم الدخول",
    "hdgz": "قواعد الحدث",
    "qdjl2": "تسجيل الوصول",
    "qdcg": "تسجيل الدخول بنجاح",
    "yhd": "مكتسبة",
    "lq": "تلقي",
    "dyt": "اليوم الأول",
    "det": "اليوم التالي",
    "dst": "اليوم الثالث",
    "dsit": "اليوم الرابع",
    "dwt": "اليوم الخامس",
    "dlt": "اليوم السادس",
    "dqt": "اليوم السابع",
    "jxz": "قيد التقدم",
    "cjxnzh": "إنشاء حساب افتراضي",
    "sy":"Home",
    "sc":"Market",
    "sclb":"Market List",
    "jy":"Trade",
    "zh":"Account",
    "db":"Loans",
    "zchm":"Registration Number",
    "cp":"Product",
    "tzjd":"Investment loans",
    "zxzc":"Online Support",
    "xd":"Order",
    "zzjptgmnr":"Invest in your future.Grow your portfolio in a fair and open financial system.",
    "yy":"App",
    "pqnr":"Mobile banking that breaks away from traditional rules and provides you with precise financial management tools.",
    "jiami":"Crypto",
    "tgnr":"By making deposits using crypto, you gain an extra layer of security and ensure fast transaction processing.",
    "jyl":"24h Trading Volume",
    "ssjmhb":"Crypto listing",
    "zchy":"Registered Users",
    "djxz":"Click to Download",
    "azsc":"Android Market",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  "langNew":{
    "szhb": "عملة مشفرة",
    "gjs": "معدن",
    "yy": "خام",
    "jy": "تجارة",
    "jmhb": "عملة مشفرة",
    "yxhy": "عقد دائم",
    "gdjy": "طلب معلق",
    "khh": "فتح حساب",
    "qsrkhh": "الرجاء إدخال بنك حسابك",
    "yhkh": "رقم البطاقة المصرفية" ,
    "qsryhkh": "الرجاء إدخال رقم بطاقتك المصرفية",
   },
   kdkje: 'مبلغ القرض المتاح'
}



// WEBPACK FOOTER //
// ./src/lang/alb.js